import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import Sidebar from './Sidebar';
import MobileMenu from './MobileMenu';

import { getProfile } from '../../actions/storage';
import { getCookie } from '../../helpers/Storage';

const Layout = () => {
    const dispatch = useDispatch();

    const { pathname = "" } = useLocation();

    const token = getCookie();
    const { status, data } = useSelector(state => state.storage);

    useEffect(() => {
        dispatch(getProfile());
    }, [dispatch]);

    useEffect(() => {
        scrollHandler();
    }, [pathname]);

    const scrollHandler = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if(!token && (!data || status !== 200)){
        return <Navigate to={'/'} />
    }

    return (
        <div className='relative flex flex-col lg:flex-row min-h-screen' >
            <Sidebar />
            <MobileMenu />
            <div className='flex-1 lg:p-10 lg:pt-30 p-6 pt-24 relative'>
                <Outlet />
            </div>
        </div>
    )
}

export default Layout;